(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-showroom-3d"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll("[data-about-showroom-3d]");

    roots.forEach((root) => {
      if (root.dataset.aboutShowroomMounted === "true") return;
      root.dataset.aboutShowroomMounted = "true";

      const scroller = root.querySelector("[data-about-scroll]");
      const scenes = Array.from(root.querySelectorAll("[data-about-scene]"));
      const captions = Array.from(root.querySelectorAll("[data-about-caption]"));
      const progressEl = root.querySelector("[data-about-progress]");
      const canvas = root.querySelector("[data-about-showroom-canvas]");
      const canAnimate = !(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
      const state = { progress: 0, sceneMix: 0, sceneCount: Math.max(1, scenes.length), activeIndex: 0 };

      if (!scroller || scenes.length === 0) return;

      function clamp(value, min, max) {
        return Math.max(min, Math.min(max, value));
      }

      function measureProgress() {
        const rect = scroller.getBoundingClientRect();
        const viewport = window.innerHeight || 1;
        const travel = Math.max(1, rect.height - viewport);
        return clamp((0 - rect.top) / travel, 0, 1);
      }

      function renderScroll() {
        state.progress = measureProgress();
        state.sceneMix = state.progress * (state.sceneCount - 1);
        state.activeIndex = clamp(Math.round(state.sceneMix), 0, state.sceneCount - 1);
        root.style.setProperty("--about-progress", String(state.progress));

        scenes.forEach((scene, index) => {
          const distance = Math.abs(state.sceneMix - index);
          const opacity = clamp(1 - distance, 0, 1);
          const local = clamp(state.sceneMix - index, -1, 1);
          scene.style.setProperty("--scene-opacity", opacity.toFixed(4));
          scene.style.setProperty("--scene-scale", (1.08 - opacity * 0.055 + Math.abs(local) * 0.018).toFixed(4));
          scene.style.setProperty("--scene-y", `${(-local * 16).toFixed(2)}px`);
          scene.style.setProperty("--scene-x", `${(local * 9).toFixed(2)}px`);
          scene.classList.toggle("is-active", index === state.activeIndex);
        });

        captions.forEach((caption, index) => {
          const distance = Math.abs(state.sceneMix - index);
          const opacity = clamp(1 - distance * 1.4, 0, 1);
          caption.style.setProperty("--caption-opacity", opacity.toFixed(4));
          caption.style.setProperty("--caption-y", `${(distance * 18).toFixed(2)}px`);
          caption.classList.toggle("is-active", index === state.activeIndex);
        });

        if (progressEl) {
          progressEl.style.width = `${(state.progress * 100).toFixed(2)}%`;
        }
      }

      let ticking = false;
      function requestRender() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          ticking = false;
          renderScroll();
        });
      }

      renderScroll();
      window.addEventListener("scroll", requestRender, { passive: true });
      window.addEventListener("resize", requestRender);

      if (canAnimate && canvas && root.getAttribute("data-about-enable-scene") === "true") {
        hydrateWebgl(root, canvas, state);
      }
    });

    function hydrateWebgl(root, canvas, state) {
      const gl = canvas.getContext("webgl", { alpha: true, antialias: true });
      if (!gl) return;

      const vertexShader = compile(gl, gl.VERTEX_SHADER, `
        attribute vec2 a_position;
        attribute float a_phase;
        uniform float u_time;
        uniform float u_progress;
        uniform float u_aspect;
        varying float v_phase;
        void main() {
          float wave = sin(u_time * 0.55 + a_phase + u_progress * 5.2) * 0.012;
          vec2 p = a_position + vec2(wave, cos(u_time * 0.4 + a_phase) * 0.006);
          p.x = p.x / max(u_aspect, 0.72);
          gl_Position = vec4(p, 0.0, 1.0);
          gl_PointSize = 2.0 + sin(a_phase + u_time) * 1.2;
          v_phase = a_phase;
        }
      `);
      const fragmentShader = compile(gl, gl.FRAGMENT_SHADER, `
        precision mediump float;
        uniform float u_time;
        uniform float u_progress;
        varying float v_phase;
        void main() {
          float shimmer = 0.56 + sin(u_time * 0.9 + v_phase + u_progress * 4.0) * 0.28;
          gl_FragColor = vec4(1.0, 0.82, 0.52, 0.26 * shimmer);
        }
      `);
      const program = gl.createProgram();
      gl.attachShader(program, vertexShader);
      gl.attachShader(program, fragmentShader);
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return;

      const positionLocation = gl.getAttribLocation(program, "a_position");
      const phaseLocation = gl.getAttribLocation(program, "a_phase");
      const timeLocation = gl.getUniformLocation(program, "u_time");
      const progressLocation = gl.getUniformLocation(program, "u_progress");
      const aspectLocation = gl.getUniformLocation(program, "u_aspect");
      const buffer = gl.createBuffer();
      const vertices = createThreadVertices();
      let width = 1;
      let height = 1;
      let active = true;

      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.STATIC_DRAW);
      gl.enable(gl.BLEND);
      gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
      root.classList.add("is-webgl-ready");

      function compile(localGl, type, source) {
        const shader = localGl.createShader(type);
        localGl.shaderSource(shader, source);
        localGl.compileShader(shader);
        return shader;
      }

      function curvePoint(start, control, end, t) {
        const mt = 1 - t;
        return [
          mt * mt * start[0] + 2 * mt * t * control[0] + t * t * end[0],
          mt * mt * start[1] + 2 * mt * t * control[1] + t * t * end[1]
        ];
      }

      function createThreadVertices() {
        const data = [];
        const curves = [
          [[-0.78, 0.78], [-0.16, 0.18], [0.62, -0.78]],
          [[0.72, 0.72], [0.2, 0.1], [-0.5, -0.72]],
          [[-0.42, 0.86], [0.04, 0.24], [0.18, -0.82]],
          [[0.46, 0.82], [-0.06, 0.22], [-0.2, -0.8]],
          [[-0.92, -0.12], [-0.08, 0.06], [0.9, -0.18]],
          [[-0.7, 0.2], [0.02, 0.44], [0.74, 0.08]]
        ];
        curves.forEach((curve, curveIndex) => {
          for (let i = 0; i < 34; i += 1) {
            const a = i / 34;
            const b = (i + 1) / 34;
            const pointA = curvePoint(curve[0], curve[1], curve[2], a);
            const pointB = curvePoint(curve[0], curve[1], curve[2], b);
            const phase = curveIndex * 0.77 + i * 0.08;
            data.push(pointA[0], pointA[1], phase, pointB[0], pointB[1], phase + 0.04);
          }
        });
        for (let i = 0; i < 42; i += 1) {
          const x = -0.9 + Math.random() * 1.8;
          const y = -0.84 + Math.random() * 1.62;
          const phase = i * 0.31;
          data.push(x, y, phase, x + 0.002, y + 0.002, phase);
        }
        return data;
      }

      function resize() {
        const rect = canvas.getBoundingClientRect();
        width = Math.max(1, Math.round(rect.width));
        height = Math.max(1, Math.round(rect.height));
        const ratio = Math.min(window.devicePixelRatio || 1, 1.75);
        canvas.width = Math.round(width * ratio);
        canvas.height = Math.round(height * ratio);
        gl.viewport(0, 0, canvas.width, canvas.height);
      }

      function render(time) {
        if (active) {
          gl.clearColor(0, 0, 0, 0);
          gl.clear(gl.COLOR_BUFFER_BIT);
          gl.useProgram(program);
          gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
          gl.enableVertexAttribArray(positionLocation);
          gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 12, 0);
          gl.enableVertexAttribArray(phaseLocation);
          gl.vertexAttribPointer(phaseLocation, 1, gl.FLOAT, false, 12, 8);
          gl.uniform1f(timeLocation, time * 0.001);
          gl.uniform1f(progressLocation, state.progress);
          gl.uniform1f(aspectLocation, width / Math.max(height, 1));
          gl.drawArrays(gl.LINES, 0, vertices.length / 3);
        }
        window.requestAnimationFrame(render);
      }

      if ("ResizeObserver" in window) {
        const observer = new ResizeObserver(resize);
        observer.observe(canvas);
      } else {
        window.addEventListener("resize", resize);
      }

      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            active = entry.isIntersecting;
          });
        }, { threshold: 0.02 });
        observer.observe(root);
      }

      resize();
      window.requestAnimationFrame(render);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
